<template>
  <!-- Banner -->
  <section id="banner">
    <div class="inner">
      <header>
        <h2>shortener</h2>
      </header>
      <p>
        This is a free
        <strong>URL shortener</strong>
        <br>integrated to D2SI domain
        <br>running in AWS with
        <span class="icon fa-heart">
          <span class="label">love</span>
        </span>
      </p>
      <footer>
        <ul class="buttons stacked">
          <li>
            <a class="button fit" v-on:click="getstarted">Get started</a>
          </li>
        </ul>
      </footer>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {}
  },
  methods: {
    getstarted: function () {
      this.$router.push('/create')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue